import { FC, Fragment } from "react";
import React from "react";
import { ChangeNames } from "../../clients/FirebaseClient/types";
import { useFormModel } from "../core/FormModelHelpes";
import { NumberInput } from "../core/NumberField";
import { useStyles } from "../../useStyles";
import { Switch } from "../core/Switch";
import { ChargingDeviceIcon } from "../core/icons/Icons";
import { BoxedInputWithIconAndOptionalSwitch } from "../core/BoxedInputWithIconAndOptionalSwitch";
import { InputLabel } from "@material-ui/core";
import { FormControlLabel } from "../core/FormControlLabel";
import { Checkbox } from "../core/Checkbox";

export const IncreaseCurrentElectricLoaderForm: FC = () => {
    const classes = useStyles();
    const { values, getFieldProps, setValues } = useFormModel<
        ChangeNames.INCREASE_CURRENT_ELECTRIC_LOADER
    >();
    return (
        <Fragment>
            <BoxedInputWithIconAndOptionalSwitch
                icon={<ChargingDeviceIcon />}
                content={
                    <Fragment>
                        <p className={classes.label} style={{ marginBottom: 8 }}>
                            Ladeeinrichtung
                        </p>
                        <p className={classes.p} style={{ marginTop: 0, marginBottom: 24 }}>
                            Sofern bereits heute eine Ladeeinrichtung an der Bauadresse existiert,
                            ist diese hier zu erfassen. Die Option ist nur zu aktivieren, wenn Sie
                            bereits eine bestehende Ladeeinrichtung am Netz angeschlossen haben.
                        </p>
                        <p className={classes.p} style={{ marginTop: 0, marginBottom: 24 }}>
                            Möchten Sie ausschließlich eine weitere Ladeeinrichtung beantragen,
                            nutzen Sie hierfür bitte den Prozess &quot;Ladeeinrichtung&quot;.
                        </p>
                    </Fragment>
                }
                useSwitch={
                    <Switch
                        checked={values.increaseCurrentElectricLoader.value.installed}
                        {...getFieldProps("increaseCurrentElectricLoader.value.installed")}
                        onChange={(e, checked) =>
                            setValues(values => {
                                values.increaseCurrentElectricLoader.value.installed = checked;
                                values.increaseCurrentElectricLoader.value.demand.amount = checked
                                    ? 0
                                    : null;
                            })
                        }
                    />
                }
                detailCondition={values.increaseCurrentElectricLoader.value.installed}
                detail={
                    <Fragment>
                        <InputLabel className={classes.labledTextfieldLabel}>
                            Summe der Leistung
                        </InputLabel>
                        <NumberInput
                            className={classes.textField}
                            decimalScale={
                                values.increaseCurrentElectricLoader.value.demand.precision
                            }
                            allowLeadingZeros={false}
                            allowNegative={false}
                            thousandSeparator="."
                            decimalSeparator=","
                            adornment={values.increaseCurrentElectricLoader.value.demand.unit}
                            value={values.increaseCurrentElectricLoader.value.demand.amount || ""}
                            placeholder="0"
                            onValueChange={v =>
                                setValues(values => {
                                    values.increaseCurrentElectricLoader.value.demand.amount =
                                        v.floatValue || null;
                                })
                            }
                            error={values.increaseCurrentElectricLoader.error != null}
                        />
                        <br />
                        <FormControlLabel
                            style={{ marginBottom: 24 }}
                            isCheckBox={true}
                            control={
                                <Checkbox
                                    value="ja"
                                    checked={values.increaseCurrentElectricLoader.value.notKnown}
                                    onChange={(event, checked) =>
                                        setValues(values => {
                                            values.increaseCurrentElectricLoader.value.notKnown = checked;
                                        })
                                    }
                                />
                            }
                            label="Leistungswert nicht bekannt"
                            error={false}
                        />
                    </Fragment>
                }
            />
        </Fragment>
    );
};
